import { render } from "./OllamaScreen.vue?vue&type=template&id=08fde434&scoped=true"
import script from "./OllamaScreen.vue?vue&type=script&lang=js"
export * from "./OllamaScreen.vue?vue&type=script&lang=js"

import "./OllamaScreen.vue?vue&type=style&index=0&id=08fde434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fde434"]])

export default __exports__